import TorListe from "@/pages/Dashboardlisten/TorListe";
import TorAbschlussSimulieren from "@/components/Tor/TorAbschlussSimulieren";
import PromotionsuebersichtModulunterricht from "@/pages/Bildung/PromotionsuebersichtModulunterricht";

export default [
	{
		path: "/TorListe",
		name: "tor-liste",
		component: TorListe,
	},
	{
		path: "/TorAbschlussSimulieren",
		name: "tor-abschluss-simulieren",
		component: TorAbschlussSimulieren,
	},
		{
		path: "/Promotionsuebersicht-Modulunterricht",
		name: "promotionsuebersicht-modulunterricht",
		component: PromotionsuebersichtModulunterricht,
	},

];
